// extracted by mini-css-extract-plugin
export default {"pageWrapper":"MainPage_pageWrapper__Hybl7","table":"MainPage_table__R--tC","tableWidget":"MainPage_tableWidget__FXR5K"};